import {COLORS} from "../../../ui/Theme";
import {Box,Avatar, Typography} from "@mui/material";

const DerivativesStrategiesSymbol = ({title, avatar, selected, onClick}) => {

    return (
        <Box
            onClick={onClick}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
                backgroundColor: selected ? "#E3F2FD" : COLORS.WHITE,
                minWidth: "100px",
                height: "40px",
                cursor: "pointer",
                border: "1px solid",
                borderColor: selected ? "#BBDEFB" : "#EEEEEE",
                borderRadius: "18px",
                transition: "all 0.3s ease",

                "&:hover": {
                    backgroundColor: "#E3F2FD80",
                    borderColor: "#BBDEFB",
                    "& .hover-typography": {
                        color: COLORS.BLUE,
                    },
                },
            }}
        >
            <Avatar
                sx={{
                    width: "24px",
                    height: "24px",
                    backgroundColor: COLORS.WHITE,
                    border: "1px solid #EEEEEE",
                    borderRadius: "100%",
                    color: "#0000008F",
                }}
            >
                {avatar}
            </Avatar>
            <Typography
                className="hover-typography"
                sx={{
                    fontSize: "14px",
                    fontWeight: 900,
                    transition: "color 0.3s ease",
                }}
            >
                {title}
            </Typography>
        </Box>
    )
}
export default DerivativesStrategiesSymbol;